import React, { useMemo, useEffect, useState, useCallback, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { UnidataTable, Modal } from '~/components';
import { t } from '~/helpers';

import { isEqual } from 'lodash';
import { canURL } from '~/helpers';

import { Edit, Cancel, LockOpen } from '@material-ui/icons';

import {
  ADM, GFE, GFO, GFU, SERVICE_DESK, GFE_CONSULTA,
  GFO_CONSULTA,
  GFU_CONSULTA,
  GPPE_CONSULTA,
  GPP_CONSULTA,
  FRENTISTA_CONSULTA,
  GPPEM,
  GPPE,
  CONSULTA_OPERACAO
} from '~/constants/perfil';
import { format, setHours, setMinutes, setSeconds, subDays, parseISO } from 'date-fns';
//import Tabs from './tabs';

import {
  cadastroUsuarioMasterInRequest,
  findCadastroUsuarioMaster,
  deleteCadastroUsuarioMaster,
  recordFiltering,
  unblockUsuarioMaster
} from '~/store/modules/cadastrousuariomaster/actions';

import { Heading, Form } from './components';

function CadastroUsuarioMasterList() {
  const dispatch = useDispatch();
  const formRef = React.useRef(null);
  const modalRef = useRef(null)

  const { profile } = useSelector((state) => state.user);


  //const permission = canURL();






  const cadastrousuariomaster = useSelector(
    (state) => state.cadastrousuariomaster
  );


  const data = useSelector((state) => state.cadastrousuariomaster);

  const [modal, setModal] = React.useState(false);
  const [params, setParams] = React.useState({});

  const [habAlterar, setHabAlterar] = useState(false);
  const [habDesbloq, setHabDesbloq] = useState(false);
  const [habDelete, setHabDelete] = useState(true)

  const [selectedRow, setSelectedRow] = useState({})

  //isEqual(canURL(), { update: true })

  useEffect(() => {
    let mounted = true;
    //buttons = buttons.slice(0);
    if (mounted) {
      //switch (profile.glousuariotipo) {

      const permission = canURL();

      switch (profile.gloperfilid) {
        case ADM:
        case GFO:
        case SERVICE_DESK:
        case GFE:
        case GPPEM:
          if (permission.update) {
            setHabAlterar(true)
          } else {
            setHabAlterar(false)
          }
          /*
          if (isEqual(canURL(), { update: true })) {
            setHabAlterar(true)
          } else {
            setHabAlterar(false)
          }
          */

          //setHabAlterar(true)
          break;
        case GPPE: //codigo novo DAGNO 28/03/2022

          if (permission.update) {
            setHabAlterar(true)
          } else {
            setHabAlterar(false)
          }

          /*
          if (isEqual(canURL(), { update: true })) {
            setHabAlterar(true)
          } else {
            setHabAlterar(false)
          }
          */
          //setHabAlterar(true)
          break;
        default:
          setHabAlterar(false);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);
  //}, [profile, permission]);

  const listaRecebeEmailPesquisa = useMemo(() => [
    { label: 'sim', value: 'Sim' },
    { label: 'não', value: 'Não' },
  ]);

  const listaNivelAcessoPesquisa = useMemo(() => [
    { label: '1', value: 'Gestor Sistema' },
    { label: '2', value: 'Gestor de Frota do Estado' },
    { label: '3', value: 'Gestor de Frota do Órgão' },
    { label: '4', value: 'Gestor de Frota da Unidade' },
    { label: '5', value: 'Gestor de Posto do Órgão' },
    { label: '6', value: 'Gestor de Posto' },
    // { label: '7', value: 'Frentista' },
    { label: '8', value: 'Gestor de Posto Próprio Multi Posto' },
    { label: '62', value: 'Atendimento CallCent' },
    { label: '64', value: 'Service Desk' },
    { label: '65', value: 'Manutenção Abastek' },
    { label: '66', value: 'Consulta Operação' },
    { label: '67', value: 'Gestor de Frota do Estado - Consulta' },
    { label: '68', value: 'Gestor de Frota do Órgão - Consulta' },
    { label: '69', value: 'Gestor de Frota da Unidade - Consulta' },
    { label: '70', value: 'Gestor de Posto do Órgão - Consulta' },
    { label: '71', value: 'Gestor de Posto - Consulta' },
    // { label: '72', value: 'Frentista - Consulta' },
    { label: '73', value: 'Gestão OS Veículos' },
    { label: '75', value: 'Consulta Abastecimen' },
    { label: '76', value: 'Gestor Abastek Comercial' },
    { label: '77', value: 'Gestor Abastek Financeiro' },
  ]);

  const listaNivelAcessoPesquisaGFE = useMemo(() => [
    { label: '2', value: 'Gestor de Frota do Estado' },
    { label: '3', value: 'Gestor de Frota do Órgão' },
    { label: '4', value: 'Gestor de Frota da Unidade' },
    { label: '5', value: 'Gestor de Posto do Órgão' },
    { label: '6', value: 'Gestor de Posto' },
    // { label: '7', value: 'Frentista' },
    { label: '8', value: 'Gestor de Posto Próprio Multi Posto' },
    { label: '67', value: 'Gestor de Frota do Estado - Consulta' },
    { label: '68', value: 'Gestor de Frota do Órgão - Consulta' },
    { label: '69', value: 'Gestor de Frota da Unidade - Consulta' },
    { label: '70', value: 'Gestor de Posto do Órgão - Consulta' },
    { label: '71', value: 'Gestor de Posto - Consulta' },
    // { label: '72', value: 'Frentista - Consulta' },
  ]);

  const listaNivelAcessoPesquisaGPPM = useMemo(() => [
    { label: '6', value: 'Gestor de Posto' },
    { label: '71', value: 'Gestor de Posto - Consulta' },
  ], [])

  const listaNivelAcessoPesquisaGPPE = useMemo(() => [
    { label: '5', value: 'Gestor de Posto do Órgão' },
    { label: '70', value: 'Gestor de Posto do Órgão - Consulta' },
    { label: '6', value: 'Gestor de Posto' },
    { label: '71', value: 'Gestor de Posto - Consulta' },
  ], [])


  const listaNivelAcessoPesquisaGFO = useMemo(() => [
    { label: '4', value: 'Gestor de Frota da Unidade' },
    { label: '69', value: 'Gestor de Frota da Unidade - Consulta' }
  ]);


  const listaAprovaPreFaturaPesquisa = useMemo(() => [
    { label: 'S', value: 'Sim' },
    { label: 'N', value: 'Não' },
  ]);

  const listaStatusPesquisa = useMemo(() => [
    { label: '1', value: 'liberado' },
    { label: '2', value: 'bloqueado' },
    { label: '3', value: 'cancelado' },
  ]);

  const listaBloqueioPorAcesso = useMemo(() => [
    { label: 'S', value: 'Sim' },
    { label: 'N', value: 'Não' }
  ])

  const buttons = useMemo(() => {
    let arrayButtons = []

    if (habAlterar) {
      arrayButtons.push({
        title: t('s.geral.botaoalterar'),
        action: (value) => handleOpenModalEdit(value),
        icon: <Edit />,
      })
    }
    // if (habDesbloq) {
    //   arrayButtons.push({
    //     title: 'Desbloquear',
    //     action: () => modalRef.current.handleOpenModal(),
    //     icon: <LockOpen />,
    //   })
    // }

    return arrayButtons

  }, [habAlterar])



  const header = useMemo(
    () => [
      {
        id: 'usua_login',
        label: 'Login',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'usua_nome',
        label: 'Nome',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'usua_cpf',
        label: 'Cpf',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'usua_email',
        label: 'Email',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'usua_recebe_email_str',
        label: 'Recebe Email',
        align: 'center',
        converter: listaRecebeEmailPesquisa,
        filter: {
          type: 'select',
          options: listaRecebeEmailPesquisa,
        },
      },


      {
        id: 'perf_descricao',
        label: 'Nível Acesso',
        align: 'center',
        converter: profile.glousuariotipo !== GFO ? profile.glousuariotipo !== GFE ? profile.glousuariotipo !== GPPEM ? profile.glousuariotipo !== GPPE ? listaNivelAcessoPesquisa : listaNivelAcessoPesquisaGPPE : listaNivelAcessoPesquisaGPPM : listaNivelAcessoPesquisaGFE : profile.glousuariotipo !== GPPEM ? listaNivelAcessoPesquisaGFO : listaNivelAcessoPesquisaGPPM,
        filter: {
          type: 'select',
          options: profile.glousuariotipo !== GFO ? profile.glousuariotipo !== GFE ? profile.glousuariotipo !== GPPEM ? profile.glousuariotipo !== GPPE ? listaNivelAcessoPesquisa : listaNivelAcessoPesquisaGPPE : listaNivelAcessoPesquisaGPPM : listaNivelAcessoPesquisaGFE : profile.glousuariotipo !== GPPEM ? listaNivelAcessoPesquisaGFO : listaNivelAcessoPesquisaGPPM,
        },
      },

      {
        id: 'orga_nome',
        label: 'Órgão',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'poco_desc_abrev',
        label: 'Posto',
        filter: {
          type: 'string',
        },
        align: 'left',
      },

      {
        id: 'usua_aprova_pre_faturamento_str',
        label: 'Aprova Pré Fatura',
        align: 'center',
        converter: listaAprovaPreFaturaPesquisa,
        filter: {
          type: 'select',
          options: listaAprovaPreFaturaPesquisa,
        },
      },

      {
        id: 'usua_status_str',
        label: 'Status',
        align: 'center',
        converter: listaStatusPesquisa,
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
        styled: (value) =>
          value.usua_status_str === 'liberado' ? { color: '#00B300' } : { color: '#ff0000' },
      },
      {
        id: 'usua_ultimo_acesso',
        label: 'Último Acesso',
        align: 'center',
        formatted: (value) => format(parseISO(value), 'dd/MM/yyyy HH:mm'),
      },
      {
        id: 'usua_status_bloqueio_por_acesso',
        label: 'Bloqueio por tempo acesso',
        align: 'center',
        filter: {
          type: 'select',
          options: listaBloqueioPorAcesso,
        },
        formatted: (value) => value == 'S' ? 'Sim' : 'Não',

        // styled: (value) =>
        //   value.usua_status_str === 'liberado' ? { color: '#00B300' } : { color: '#ff0000' },
      },
    ],
    [profile]
  );

  const registroSelecionado = useCallback((value) => {
    setSelectedRow(value)
  }, [])


  useEffect(() => {

    if (selectedRow.perf_tipo === undefined) {
      setHabDelete(false)
      setHabAlterar(false)
    } else {

      // if (selectedRow.perf_tipo == profile.gloperfilid && profile.gloperfilid != 1) {
      if (selectedRow.perf_tipo == profile.gloperfilid
        && profile.gloperfilid != 1
        && profile.gloperfilid != 2
      ) {
        setHabDelete(false)
        setHabAlterar(false)
      } else if (profile.gloperfilid != GFE_CONSULTA &&
        profile.gloperfilid != GFO_CONSULTA &&
        profile.gloperfilid != GFU_CONSULTA &&
        profile.gloperfilid != GPPE_CONSULTA &&
        profile.gloperfilid != GPP_CONSULTA &&
        profile.gloperfilid != CONSULTA_OPERACAO &&
        profile.gloperfilid != FRENTISTA_CONSULTA
      ) {

        const permission = canURL();

        //if (isEqual(canURL(), { delete: true })) {
        if (permission.delete) {
          setHabDelete(true)
        } else {
          setHabDelete(false)
        }

        //if (isEqual(canURL(), { update: true })) {
        if (permission.update) {
          setHabAlterar(true)
        } else {
          setHabAlterar(false)
        }

      } else {
        setHabDelete(false)
        setHabAlterar(false)
      }


    }
  }, [selectedRow, profile])

  // Open Modal Edit
  const handleOpenModalEdit = React.useCallback((values) => {
    setModal(true);
    setParams(values);
  }, []);

  // Close Modal Edit
  const handleCloseModalEdit = React.useCallback(() => {
    setModal(false);
    setParams({});
    dispatch(recordFiltering(data.params));
  }, [data]);

  const handleUnblockUser = useCallback(() => {
    dispatch(unblockUsuarioMaster(selectedRow.usua_login, data.params))
    modalRef.current.handleCloseModal()
  }, [selectedRow, data])


  React.useEffect(() => {
    if (modal) {
      formRef.current.openModal();
    }
  }, [modal]);



  return (
    <>
      <UnidataTable
        pdf
        excel
        reportOrder="usua_login ASC"
        title={'Cadastro de Usuário'}
        create={false}
        delete={habDelete}
        update={false}
        fixed
        header={header}
        //form={OperacaoPreRecebimentoForm}
        //custom={filter}
        find={findCadastroUsuarioMaster}
        redux={cadastrousuariomaster}
        //read={operacaoRadAdmDadosFaturamentoUnidataInRequest}
        remove={deleteCadastroUsuarioMaster}
        read={recordFiltering}
        actions={buttons}
        detach="prre_codigo"
        keys={["prre_codigo", "usua_login"]}
        maxWidth="md"
        toolbar={Heading}
        //custom={filter}
        onRow={(values) => registroSelecionado(values)}
        view="VW_USUARIO_ACESSO"
        reportTitle="Cadastro de usuário"
      />
      {/* <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        maxWidth="xs"
        title="Desbloquear Usuário"
        component={() =>
          <div style={{ textAlign: 'center' }}>
            <p>Deseja Liberar o acesso do usuário <strong>{selectedRow.usua_login}</strong> ?</p>
          </div>
        }
        loading={cadastrousuariomaster.loading}
        actions={ActionsModal}
      /> */}

      {/* <Tabela
        noCreate
        noEdition
        read={cadastroUsuarioMasterInRequest}
        remove={deleteCadastroUsuarioMaster}
        state={cadastrousuariomaster}
        header={header}
        headerMobile="usua_login"
        unique={['usua_login']}
        //form={Tabs}
        findItem={findCadastroUsuarioMaster}
        recordFilter={recordFiltering}
        modal='lg'
        topBar={Heading}

        buttons={buttons}
      /> */}
      {modal && (
        <Form
          ref={formRef}
          onCloseModal={handleCloseModalEdit}
          formEdit={params}
        />
      )}
    </>
  );
}

export default CadastroUsuarioMasterList;
